export default __webpack_public_path__ + "static/demolition-home_mobile-8f17cc49dc25aa565c54840b978a4aca.png";